export interface FrontendRuntimeEnv {
  VITE_API_BASE_URL: string;
  VITE_CLERK_PUBLISHABLE_KEY: string;
  NODE_ENV: string;
  DEPLOY_ENVIRONMENT: string;
}

export function loadRuntimeEnv(): FrontendRuntimeEnv {
  return {
    VITE_API_BASE_URL: String(window.__ELM_ENV?.VITE_API_BASE_URL || '/api/v1'),
    VITE_CLERK_PUBLISHABLE_KEY: String(window.__ELM_ENV?.VITE_CLERK_PUBLISHABLE_KEY || ''),
    NODE_ENV: String(window.__ELM_ENV?.NODE_ENV || 'production'),
    DEPLOY_ENVIRONMENT: String(window.__ELM_ENV?.DEPLOY_ENVIRONMENT || ''),
  };
}
